import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=64ad9a22&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad9a22",
  null
  
)

export default component.exports